import i18n from "@/i18n";

export const translationKeyTransform = (string: string): string => {
  return string?.toUpperCase().split(" ").join("_");
};

export const parseRawTextWithTranslationOrNot = (rawText: string) => {
  const translationKey = rawText.toUpperCase().replaceAll(" ", "_");
  const potentialTranslation = i18n.global.t(translationKey);

  // If translation wasn't found (returns the key back), fall back
  if (!potentialTranslation || potentialTranslation === translationKey) {
    return rawText
      .replaceAll(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return potentialTranslation;
};
